export default __webpack_public_path__ + "static/media/expand.feae4dd7.svg";